import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import { IncidentListDomainService } from '../../pages/incidentsList/incidentListDomainService';
import { NoIncidentNotificationIcon } from '../Icon/NoIncidentNotificationIcon';
import { WithIncidentNotificationIcon } from '../Icon/WithIncidentNotificationIcon';
import { getInitials } from '../../helpers/initialsExtractor';
import { getRouteByAccountType } from '../../routes/getRouteByAccountType';
import { di } from '../../state/inversify.config';
import { Avatar } from '../avatar/avatar';
import { AccountTypes } from '../changeUser/accountTypes.enum';

export const IncidentHeader = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const incidentListDomainService = di.get<IncidentListDomainService>(
    IncidentListDomainService,
  );
  const user = incidentListDomainService.useUserSelector();

  const openIncidents = (() => {
    if (user?.accountType === AccountTypes.Guardian) {
      return incidentListDomainService.useOpenIncidentSelector();
    }

    return incidentListDomainService.useOrgOpenIncidentSelector();
  })();

  const navigateListIncident = () => {
    incidentListDomainService.dispatchQueryParams({
      selectedPlayerId: '',
    });

    navigate(`/${getRouteByAccountType(user?.accountType)}/incidents-list`);
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{ mb: 2 }}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <Grid item display="flex" flexDirection="row" columnGap={2}>
        <Grid item>
          {user?.firstName && user?.lastName && (
            <Avatar title={getInitials(`${user.firstName} ${user.lastName}`)} />
          )}
        </Grid>
        <Grid item display="flex" flexDirection="column">
          <Typography variant="body1">
            {t('incident.INCIDENT_LIST_WELCOME_BACK')}
          </Typography>
          <Typography
            fontWeight="bold"
            sx={{
              fontSize: {
                lg: 20,
                md: 15,
                sm: 15,
                xs: 15,
              },
            }}
          >
            {`${user?.firstName} ${user?.lastName}`}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        item
        sx={{
          m: 1,
          '&:hover': {
            cursor: 'pointer',
          },
        }}
      >
        {openIncidents && openIncidents.length <= 0 ? (
          <NoIncidentNotificationIcon
            onClick={navigateListIncident}
            height="90"
            width="105"
          />
        ) : (
          <WithIncidentNotificationIcon
            onClick={navigateListIncident}
            text={openIncidents.length.toString()}
            height="90"
            width="105"
          />
        )}
      </Grid>
    </Grid>
  );
};
